import { downloadCSV } from '@helpers/downloadCSV';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { GetAttorneyUsersResponseUserDto } from 'app/API';

const headers = ['ID', 'Email', 'Verified', 'Created'];

type TAttorneyUserCsvData = Pick<GetAttorneyUsersResponseUserDto, 'id' | 'email' | 'emailVerified' | 'createdAt'>;

export const downloadAttorneyUsersCsv = (users: TAttorneyUserCsvData[]) => {
  const array = users.map((data) => {
    return {
      id: data.id,
      email: data.email,
      emailVerified: data.emailVerified ? 'Y' : '',
      created: getAmericanTime(data.createdAt),
    };
  });

  return downloadCSV(array, headers);
};
